var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"justify-content-md-center"},[_c('div',{staticClass:"col col-md-8"},[_c('h2',[_vm._v("Sign Out...")])])])}]

export { render, staticRenderFns }